/*
 *
 * EmailVerification constants
 *
 */

export const VERIFY_EMAIL = '@FIL/APP/VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCESS = '@FIL/APP/VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = '@FIL/APP/VERIFY_EMAIL_FAILURE';
